import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLogin, setCsrfToken, setUserDetail, setIpAddress } from "../../state";


const useHandleLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const csrfToken = useSelector((state) => state.csrfToken);
    const logout = async () => {
        try {
            const response = await fetch(`${window.config.base_api_url}/logout`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "xsrf-token": csrfToken
                },
                credentials: "include",
            });
            console.log(1111)
            dispatch(setLogin({ user: null, token: null }));
            dispatch(setCsrfToken({ csrfToken: null }));
            dispatch(setIpAddress({ ipAddress: null }));
            dispatch(setUserDetail({
                Id: null, img_src: null, fullname: null, firstname: null,
                lastname: null, email: null, app_id: null, user_type: null, permissions: null
            }));

            navigate("/login");

        } catch (error) {
            console.error("Logout failed:", error);
            dispatch(setLogin({ user: null, token: null }));
            navigate("/");
        }
    };



    return logout;
};

export default useHandleLogout;
